import { render, staticRenderFns } from "./ProdutoCarrinhoBtn.vue?vue&type=template&id=0b285709&scoped=true"
import script from "./ProdutoCarrinhoBtn.vue?vue&type=script&lang=js"
export * from "./ProdutoCarrinhoBtn.vue?vue&type=script&lang=js"
import style0 from "./ProdutoCarrinhoBtn.vue?vue&type=style&index=0&id=0b285709&prod&lang=css"
import style1 from "./ProdutoCarrinhoBtn.vue?vue&type=style&index=1&id=0b285709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b285709",
  null
  
)

export default component.exports